"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _universalH5PageApi = require("@/api/universalH5PageApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomOfficialEvents',
  data: function data() {
    return {
      queryData: {
        name: '',
        page: {
          page: 1,
          size: 10
        }
      },
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      dataList: []
    };
  },
  created: function created() {
    this.listPageApi();
  },
  methods: {
    // 查询
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listPageApi();
    },
    // 初始化
    onInit: function onInit() {
      this.queryData = {
        name: '',
        status: '',
        unionCode: '',
        page: {
          page: 1,
          size: 10
        }
      };
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.listPageApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listPageApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listPageApi();
    },
    // 选择
    onSelectEvents: function onSelectEvents(value) {
      console.log('data', value);
      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
        Display_type: 4,
        // 区分类型
        Display_name: '通用H5活动' // 名字
      });
      this.$emit('SelectEvents', data);
      // this.onInit()
    },
    // 列表
    listPageApi: function () {
      var _listPageApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _universalH5PageApi.listPageApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listPageApi() {
        return _listPageApi2.apply(this, arguments);
      }
      return listPageApi;
    }()
  }
};